import cn from 'classnames';
import React from 'react';
import { ThemeMode, useProviderTheme } from '../../hooks';
import { Text } from '../../Text/Text';
import './WidgetsHeadline.scss';

export interface WidgetsHeadlineProps {
  content: string;
  // Buttons or other control elments to display on the right
  // hand side.
  buttons?: JSX.Element;
  icon?: JSX.Element;
}

export const WidgetsHeadline: React.FC<WidgetsHeadlineProps> = ({ content, buttons, icon }) => {
  const { mode } = useProviderTheme();

  return (
    <div
      className={cn('widgets-headline', {
        ['dark']: mode === ThemeMode.Dark,
      })}
    >
      {icon && <div className="headline-icon">{icon}</div>}
      <Text as="h2" className="headline-text">
        <div className={'inner'}>
          <div className={'text'}>{content}</div>
          {buttons}
        </div>
      </Text>
    </div>
  );
};
